
const SimpleCard = (props) => {
    return (<div className="w-full md:w-1/4 lg:w-1/4">
                <div className="widget w-full p-4 rounded-lg  bg-blue-400 border border-gray-100 dark:bg-gray-900 dark:border-gray-800 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                    <div className="flex flex-row items-center justify-between">
                        <div className="flex flex-col">
                            <div className="text-xs uppercase font-light text-gray-200">
                                {props.name}
                            </div>
                            <div className="text-2xl text-gray-100 font-bold">
                                {props.number}
                            </div>
                        </div>
                        <svg className="stroke-current text-gray-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2">
                            </path>
                            <circle cx="9" cy="7" r="4">
                            </circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87">
                            </path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75">
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
        );
}

export default SimpleCard;